import { db } from "../../firebase";
import { collection, doc, setDoc, updateDoc, getDoc, Timestamp } from "firebase/firestore";

interface DataType {
	id: string;
	first_name?: string;
	last_name?: string;
	artist_name?: string;
	is_active?: Boolean;
	email?: string;
	created?: string;
	modified?: string;
	profile_url?: string;
}

const viewRecord = async (recordId: string): Promise<DataType | null> => {
	console.log("user id: " + recordId);
	try {
		const docRef = doc(db, "users", recordId);
		const docSnap = await getDoc(docRef);
		if (docSnap.exists()) {
			return {
				id: docSnap.id,
				...docSnap.data()
			};
		} else {
			return null;
		}
	} catch (error) {
		console.error("Error viewing user: ", error);
		return null;
	}
};

async function addRecord(uid, newRecord) {
	try {
		const docRef = doc(db, "users", uid);
		await setDoc(docRef, newRecord);
	} catch (error) {
		console.error("Error adding user: ", error);
	}
}

const editRecord = async (documentId: string, updates: { [key: string]: any }) => {
	try {
		const docRef = doc(db, "users", documentId);
		await updateDoc(docRef, updates);
	} catch (error) {
		throw error;
	}
};

export const getFormattedDate = (date: Timestamp | string | undefined): string => {
	if (!date) return "";
	const dateObj = typeof date === "string" ? new Date(date) : date.toDate();
	return dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }) + " " + dateObj.toLocaleDateString("en-US");
};

export { addRecord, editRecord, viewRecord };
